import { render, staticRenderFns } from "./Login.Detail.vue?vue&type=template&id=b60bd750&"
import script from "./Login.Detail.vue?vue&type=script&lang=js&"
export * from "./Login.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports